import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  async submit(event) {
    event.preventDefault()
    event.stopPropagation()
    const button = this.element.querySelector("button[role='switch']")
    if (button.disabled) return
    const body = new FormData(this.element)
    button.disabled = true
    button.setAttribute("aria-busy", "true")
    this.abort = new AbortController()
    try {
      const response = await fetch(this.element.action, {
        method: "POST",
        body,
        signal: this.abort.signal,
        headers: {
          Accept: "application/json",
          "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")?.content || ""
        }
      })
      if (response.redirected || !response.headers.get("content-type")?.includes("application/json")) {
        throw new Error("Не удалось сохранить. Проверьте соединение и вход в аккаунт.")
      }
      const result = await response.json()
      if (!response.ok) throw new Error(result.error || "Не удалось сохранить переключение.")
      button.classList.toggle("is-enabled", result.enabled)
      button.setAttribute("aria-checked", String(result.enabled))
      const label = button.getAttribute("aria-label").replace(/^(Включить|Выключить)/, result.enabled ? "Выключить" : "Включить")
      button.setAttribute("aria-label", label)
      button.title = label
      this.element.querySelector("input[name$='[enabled]']").value = result.enabled ? "0" : "1"
    } catch (error) {
      if (error.name !== "AbortError") this.showError(error.message)
    } finally {
      button.disabled = false
      button.removeAttribute("aria-busy")
    }
  }

  showError(message) {
    this.notice?.remove()
    clearTimeout(this.timeout)
    this.notice = document.createElement("div")
    this.notice.className = "catalog-toggle-notice alert alert-danger shadow"
    this.notice.setAttribute("role", "alert")
    this.notice.textContent = message
    document.body.append(this.notice)
    this.timeout = setTimeout(() => this.notice?.remove(), 6000)
  }

  disconnect() {
    this.abort?.abort()
    clearTimeout(this.timeout)
    this.notice?.remove()
  }
}
